module.exports = __webpack_public_path__ + "img/background-profile.c7242137.png";